var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-monitor',{attrs:{"idKey":"modelarts_pool_id","data":_vm.data,"constants":_vm.cMonitorConstants}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }